import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { MaterialModule } from '../material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [HeaderComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        // ToastrModule.forRoot(),
        ReactiveFormsModule,
        // ShareModule
        TranslateModule.forChild(),
    ],
    exports: [HeaderComponent],
})
export class HeaderModule { }
